module.exports = __webpack_public_path__ + "img/StaffIcon.b3881202.svg";